import { IState } from 'shared/store';

export const isConsultantChatOpenedSelector = (state: IState) => state.consultantCianChat.isOpened;
